<ca-clickable-link
  (linkClicked)="openFeedbackDetail(feedbackId)"
  [innerHtml]="'::Feedback:Received' | abpLocalization: senderName">
</ca-clickable-link>
